import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import {ThemeProvider} from "./G&CSCM/Core/ThemeContext.tsx";
import {BrowserRouter as Router, Routes, Route} from 'react-router-dom';
import config from './G&CSCM/Config/config.ts';
import { ComponentLoadingProvider } from './G&CSCM/Contexts/ComponentLoadingContext.tsx';
import { MediaLoadingProvider } from './G&CSCM/Contexts/MediaLoadingContext.tsx';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
      <ThemeProvider>
          <ComponentLoadingProvider>
              <MediaLoadingProvider>
                  <Router>
                      <Routes>
                          {/* Route pour chaque page définie dans la config */}
                          {config.PagesList.map((page, index) => (
                              <Route key={index} path={page.pageUrl} element={<App/>}/>
                          ))}
                          {/* Route par défaut si aucune page ne correspond */}
                          <Route path="*" element={<App/>}/>
                      </Routes>
                  </Router>
              </MediaLoadingProvider>
          </ComponentLoadingProvider>
      </ThemeProvider>
  </StrictMode>,
)
